import React from 'react'

import { Container } from '@mui/joy'

import i18n from '@/i18n'
import { GenericList } from '@/components/GenericList'
import { RecordingCard } from '@/components/RecordingCard'
import { MusicNote, Waveform } from '@phosphor-icons/react'
import { useParams } from 'react-router-dom'
import { PlayButton } from '@/components/PlayButton'
import { DiscoveryModeToggle } from '@/components/DiscoveryModeToggle'

export function DiscoveryModeCampaignOverviewPage() {
  const { campaignId } = useParams()
  return (
    <DiscoveryModeCampaignOverviewContainer campaignId={campaignId} />
  )
}

export function DiscoveryModeCampaignOverviewContainer({
  campaignId
}) {
  return (
    <Container>
      <h3>{i18n.t('discovery-mode-recordings')}</h3>
        <GenericList
          path={`/discovery-mode-campaign/${campaignId}/recordings`}
          showDefaultColumns={false}
          addLabel={i18n.t('add-track')}
          filterPlaceholder={i18n.t('filter-tracks')}
          canDelete={false}
          canEdit={false}
          canView={false}
          canAdd={false}
          NodeCardComponent={RecordingCard}
          Icon={MusicNote}
          canSelectViewType={false}
          showImages={true}
          canChangeSortBy={true}
          sortByFields={[
            {
              id: '-created',
              name: i18n.t('recent-to-oldest-created')
            },
            {
              id: 'name',
              name: i18n.t('alphabetically')
            },
            {
              id: '-released',
              name: i18n.t('recent-to-oldest-released')
            }
          ]}
          /*filterColumns={[
            {
              id: 'status',
              type: 'select',
              placeholder: i18n.t('status'),
              options: [
                {
                  id: '',
                  name: i18n.t('all-statuses')
                },
                {
                  id: 'draft',
                  name: i18n.t('draft')
                },
                {
                  id: 'submitted',
                  name: i18n.t('submitted')
                },
                {
                  id: 'released',
                  name: i18n.t('released')
                }
              ]
            }
          ]}*/
          viewType="list"
          columns={[
            {
              id: 'has_audio',
              name: 'audio',
              render: ({ column, node }) => {
                return (
                  node[column.id] ? <><Waveform color="#00aa00" size={28} /></> : <XCircle color="#aa0000" size={28} />
                )
              }
            },
            {
              id: 'player',
              name: 'player',
              type: 'custom',
              render: ({ column, node }) => {
                if (node.audio_url) {
                  return (
                    <PlayButton recording={node} />
                  )
                }
              }
            },
            {
              id: 'thumbnail_url',
              sortable: false,
              type: 'image',
              name: i18n.t('image'),
            },
            {
              id: 'name',
              name: i18n.t('name'),
              link: true,
              getLinkHref: ({ node, column }) => `../recording/${node.id}`
            },
            {
              id: 'version',
              name: i18n.t('version'),
              type: 'text'
            },
            {
              id: 'isrc',
              name: 'isrc',
              render: ({ node }) => node.isrc
            },
            {
              id: 'discoveryModeToggle',
              name: 'discovery-mode',
              render: ({ node, refetch }) => {
                return <DiscoveryModeToggle onToggled={() => refetch()} recording={node} />
              }
            }
          ]}
          heading={i18n.t('tracks')}
          addUrl={`../recording/add`}
          baseUrl={`recording`}
        />
      
    </Container>
  )
}

export default DiscoveryModeCampaignOverviewPage;